import { buildAction } from 'store/actions/actionCreator'

import { FETCH_COMPANIES } from './constants'

export const fetchCompanies = buildAction(FETCH_COMPANIES, 'payload')
